import { httpsCallable } from 'firebase/functions';
import { functions } from '../services/firebase';

// Función para corregir el estado de aprobación de un usuario específico
export const fixUserApproval = async (userId = '0lFLcHpWfkgpiIs08dFYLCsgePj2') => {
  try {
    console.log(`🔧 Corrigiendo usuario: ${userId}`);
    
    const fixUserApprovalFunction = httpsCallable(functions, 'fixUserApproval');
    const result = await fixUserApprovalFunction({});
    
    console.log('✅ Usuario corregido:', result.data);
    return result.data;
    
  } catch (error) {
    console.error('❌ Error corrigiendo usuario:', error);
    throw error;
  }
};

// Función para verificar y corregir automáticamente usuarios problemáticos
export const checkAndFixUserApproval = async (userClaims) => {
  // Verificar si el usuario tiene approved: true pero no tiene tenantId
  if (userClaims && userClaims.approved === true && !userClaims.tenantId) {
    console.warn('⚠️ Detectado usuario aprobado sin tenantId - corrigiendo...');
    try {
      await fixUserApproval();
      return true; // Indica que se corrigió
    } catch (error) {
      console.error('❌ Error corrigiendo usuario automáticamente:', error);
      return false;
    }
  }
  return false; // No se necesitó corrección
};







